import { Check } from '@mui/icons-material'
import { Button, Tab, Tabs } from '@mui/material'
import React from 'react'
import Image from '../../Image'
import { guidancePageContant } from '../../../config/pageContent'
import Text from '../../Text'
import classNames from 'classnames'

const Face7 = ({ isTab = true, bodyContainer, plans = guidancePageContant.Face5.plans }: {
    isTab?: boolean, bodyContainer?: string, plans?: Array<{
        Title?: string, amount?: string, color?: string, image?: string, perks?: Array<string>, subTitle?: string
    }>
}) => {
    const [value, setValue] = React.useState(0);


    const handleChange = (event: any, newValue: any) => {
        setValue(newValue);
    };
    return (<>

        <div className='pt-[69px] pb-[99px] flex justify-center flex-col items-center'>
            <div>
                <Text className='text-[47px] font-bold'>
                    {guidancePageContant.Face5.designRoadMap}
                </Text>
            </div>
            {isTab && <div className='mt-[71px] mb-[46px]'>
                <Tabs value={value} classes={{
                    indicator: "!bg-none !bg-transparent"
                }} onChange={handleChange} className='border border-[#00000040]  rounded-[13px] px-[16px] py-[14px] ' aria-label="basic tabs example">

                    {
                        guidancePageContant.Face5.tabs.map((items) => {
                            return <Tab
                                className='!h-[78px] !w-[281px]'
                                classes={{
                                    selected: "!bg-[#2771E7] !text-white !rounded-[11px] !border-none"
                                }}
                                label={<>
                                    <Text className='text-[23px] font-bold'>
                                        {items.Title}
                                    </Text>
                                    <Text className='text-[18px] font-medium'>
                                        {items.description}
                                    </Text>
                                </>
                                } />
                        })
                    }
                </Tabs>
            </div>}
            <div className={classNames(bodyContainer, 'flex gap-[36.2px]')}>
                {plans.map(({ Title, amount, color, image, perks, subTitle }) => {
                    return <>
                        <div className={`bg-[${color}] p-[40.67px] flex flex-col min-w-[371px] max-w-[371px]  border-t-[12px] border-[${color}] bg-opacity-[10%] rounded-lg `}>
                            <div className='text-[#000000] text-[28px] font-bold w-full flex justify-center'>
                                {Title}
                            </div>
                            <div className='flex justify-center w-full mt-[33px]'>
                                <Image
                                    src={image}
                                    alt="Plan1"
                                />
                            </div>
                            <div className='mt-[33.66px]'>
                                <div className='text-[#1B1D21] text-[16px]'>
                                    {subTitle}
                                </div>
                                <div className={`text-[40px] mt-[41px] justify-center flex font-semibold text-[${color}] items-center gap-[4px]`} >
                                    ${amount}<span className='text-[16px] text-[#1B1D21] font-normal'>/month</span>
                                </div>
                            </div>
                            <div className='mt-[71px] flex flex-col justify-between h-full'>
                                <ul className='flex text-[#1B1D21] font-[14px] flex-col gap-[24px]'>
                                    {
                                        perks?.map(data => {
                                            return <li className='flex gap-[5px]  items-center'>
                                                <Check className='bg-[white] p-1 !stroke-2 rounded-full text-[#5AC587]' /> {data}
                                            </li>
                                        })
                                    }

                                </ul>
                                <div className='mt-[41px]'>
                                    <Button variant='outlined' className={`hover:!bg-opacity-100 !bg-[${color}] !bg-opacity-[0.1]  !text-[${color}] !border !border-[${color}] !w-full rounded-2xl !text-lg gap-4 !mt-4 !capitalize  !p-6 !font-bold hover:!text-white`}>
                                        Get Started
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </>
                })
                }
            </div>
        </div>
    </>
    )
}

export default Face7